/*
================================================================ 
         Copyright (c) 2018-2020 Digitize Things Inc.           
                     All rights reserved.                       
================================================================ 
*/
import actionTypes from "../actions";
// msg type true for info green and false for err,
const initialState = {
  errMsg: "",
  msgType: false,
  warning: null,
  countriesList: [],
};
const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_ERROR_MSG:
      return {
        ...state,
        errMsg: action.errMsg,
        msgType: action.msgType,
        warning: action.warning ? action.warning : null,
      };
    case actionTypes.GLOBAL_COMP_DID_MOUNT:
      return {
        ...state,
        errMsg: "",
        msgType: "",
      };
    case actionTypes.SET_COUNTRIES_LIST:
      return {
        ...state,
        countriesList: action.data,
      };
    default:
      return state;
  }
};

export default reducer;
